import { basicAxios } from "../../sevices/baseAxios";



//get Profile Data
export const getProfileData = async (id) => {
  const response = await basicAxios.get(`/api/Profile/GetProfileDataById?id=${id}`);
  return response.data;
};

//edit Profile Data
export const editProfileData = async (data) => {
    // console.log(data, "det")
  const response = await basicAxios.post("/api/Profile/EditProfileData", data);
  return response.data;
};


